import { deleteModalEntryWithData } from "../../api/deleteModalEntryWithData";
import { deleteModalEvidentionEntry } from "../../api/deleteModalEvidentionEntry";
import { getUserEntryByType } from "../../api/getTerapijeModalData";
export const fetchTerapijeModalData = async (
  eventType,
  userId,
  accessToken,
  setModalData,
  setCloseModal
) => {
  const response = await getUserEntryByType(eventType, userId, accessToken);
  setModalData(response);
};

export const handleDeleteEntry = async (
  eventId,
  userId,
  accessToken,
  eventType,
  setModalData,
  setCloseModal,
  setDeleteFlag,
  deleteFlag,
  item,
  setLoadingEventRow,
  index
) => {
  setLoadingEventRow((prev) => ({ ...prev, [index]: true }));
  if (eventType === "therapy_manual" && item?.otherInfo.therapistId) {
    const data = {
      therapistId: item?.otherInfo.therapistId,
      date: item?.otherInfo.date,
      brojSati: item?.otherInfo.brojSati,
      eventType: "manual_work_with_client",
    };

    await deleteModalEntryWithData(data, accessToken);
  } else if (
    eventType === "manual_work_with_client" &&
    item?.otherInfo.clientId
  ) {
    const data = {
      clientId: item?.otherInfo.clientId,
      date: item?.otherInfo.date,
      brojSati: item?.otherInfo.brojSati,
      eventType: "therapy_manual",
    };

    await deleteModalEntryWithData(data, accessToken);
  } else {
    console.error("Invalid eventType");
  }
  const response = await deleteModalEvidentionEntry(eventId, accessToken);
  if (response.status === 200) {
    fetchTerapijeModalData(
      eventType,
      userId,
      accessToken,
      setModalData,
      setCloseModal
    );
  }
  setDeleteFlag(!deleteFlag);
  setLoadingEventRow((prev) => ({ ...prev, [index]: false }));
};

export const radionicaType = (eventType) => {
  switch (eventType) {
    case "godina_OR":
      return "Godina OR-a";
    case "godina_eOR":
      return "Godina eOR-a";
    case "godina_RAR":
      return "RAR";
    case "godina_eRAR":
      return "eRAR";
    case "asistiranjeLjetniIPDIntenziv":
      return "Ljetni intenziv";
    case "asistiranjeModulUzivo_eOR":
      return "Modul uživo eOR-a";
    case "asistiranjeVikendIntenzivi":
      return "Vikend intenziv";
    case "asistiranjeFakultativneRadionice":
      return "Fakultativna radionica";
    default:
      return "Nepoznato";
  }
};
